<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="About" matTooltip="About">
    <mat-icon>{{ icon }}</mat-icon>
</button>

<mat-menu #menu="matMenu" [hasBackdrop]="true">
    <ng-template matMenuContent>
        <qp-about></qp-about>
    </ng-template>
</mat-menu>